import { CancelComponent } from './cancel.component';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { defs } from '../../../defs';

@Injectable()
export class CancelModalService {
	dialogRef: MatDialogRef<CancelComponent>;
	constructor(private dialog: MatDialog, private router: Router) {}

	open(): void {
		this.dialogRef = this.dialog.open(CancelComponent, {
			width: '350px'
		});

		localStorage.setItem(defs.previousUrl, this.router.url);
	}
}
